import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography, SectionCollapse } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'

import { DaysDropdown } from 'pages/chatbot/ui/FollowUpSettings/DaysDropdown'
import { ChatbotActions } from '../ChatbotActions'
import { FallbackSettings } from './FallbackSettings'

export const StepFallbackActions = observer(() => {
  const {
    errors,
    fallbackActions,
    model: { settings },
  } = useChatbotContext()

  const error = errors.getError('fallback_actions')
  const isOwnError = errors.hasOwnError('fallback_actions')
  const isNestedError =
    errors.hasError('fallback_actions') || errors.hasError('settings.followup_window')

  const fallbackActionsError = isOwnError
    ? error
    : isNestedError
    ? 'Please complete all the fields'
    : null

  const { autoFollowUpEnabled, sessionLifetime, setSessionLifetime } = settings

  useEffect(() => {
    if (!!fallbackActions.list.length && isOwnError) errors.removeError('fallback_actions')
  }, [fallbackActions.list, isOwnError])

  return (
    <SectionCollapse
      icon='failed'
      title='Choose fallback actions'
      tooltipProps={{
        label:
          'These actions will happen if your AI Agent doesn’t collect all the fields you set in your objective, or if the conversation exceeds your message limit',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={fallbackActionsError}
    >
      <FallbackSettings />
      <Typography variant={'body-lg-medium'} ariaLabel={'EndSession'}>
        End session
      </Typography>
      {autoFollowUpEnabled ? (
        <>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'EndSessionDesc'}
            color={'var(--content-primary-secondary)'}
            marginTop={4}
            marginBottom={32}
          >
            If the contact doesn’t reply within 1 day after the follow-up window
          </Typography>
        </>
      ) : (
        <DaysDropdown
          label='If the contact doesn’t reply within'
          followUpWindow={sessionLifetime}
          setFollowUpWindow={setSessionLifetime}
          days={Array(30)
            .fill(0)
            .map((_, index) => ({
              value: index + 1,
              label: String(index + 1),
            }))}
        />
      )}
      <ChatbotActions actions={fallbackActions} />
    </SectionCollapse>
  )
})
